export const VALID_PATHS = {
	CALL_MODE: 'call-mode',
	DAILY: 'chat',
	FOTO_MODE: 'foto-mode',
	SCENE: 'scene',
	SCENE_V3: 'scenes-v3',
	WORD: 'word',
};
